import React from "react";

export default function Questions() {
  return (
    <section className="questions">
      <p className="dissertation__text questions_second">
        По всем интересующим вопросам обращаться:
      </p>
      <p className="dissertation__text questions_second">
        620076 г.Екатеринбург, ул. Щербакова, 8. ГБУ СО «УрНИИДВиИ»
      </p>

      <div className="additional__links_second">
        <a
          href="tel:+73432107717"
          className="dissertation__text additional__tel"
        >
          +7 (343) 210-77-17
        </a>
        <div className="additional__links_second">
          <p className="dissertation__text questions_third">E-mail: </p>
          <a
            href="mailto:orgotdel_2008@mail.ru"
            className="dissertation__text contacts__table-tel additional__tel"
          >
            orgotdel_2008@mail.ru
          </a>
        </div>
      </div>

      <p className="dissertation__text questions_second">
        Руководитель последипломной подготовки кадров: <br></br>профессор,
        доктор медицинских наук Малишевская Нина Петровна
      </p>

      <div className="additional__links_second">
        <a
          href="tel:+73432189585"
          className="dissertation__text additional__tel"
        >
          +7 (343) 218-95-85
        </a>
        {/* <div className="additional__links_second">
          <p className="dissertation__text questions_third">E-mail: </p>
          <a
            href="mailto:urniidvii@bk.ru"
            className="dissertation__text contacts__table-tel additional__tel"
          >
            urniidvii@bk.ru
          </a>
        </div> */}
      </div>

      <p className="dissertation__text questions_second">
        Начальник отдела кадров: <br></br>Петрунина Людмила Степановна
      </p>
    </section>
  );
}
